import { VERIFICATION } from "../../constants";

export const initVerification = (user) => ({
  type: VERIFICATION.INIT_VERIFICATION,
  payload: {
    userId: user?.id || "",
    firstName: user?.first_name || "",
    lastName: user?.last_name || "",
    country: user?.country || "",
    dateBirth: user?.date_birth || "",
    email: user?.email || "",
  },
});
